import {
  createUnifiedTheme,
  defaultComponentThemes,
  genPageTheme,
  palettes,
  shapes
} from '@backstage/theme';

import DINOTBold from '../assets/fonts/DINOT-Bold.ttf';
import DINOTLight from '../assets/fonts/DINOT-Light.ttf';
import DINOTMedium from '../assets/fonts/DINOT-Medium.ttf';
import DINOTRegular from '../assets/fonts/DINOT.ttf';

export const dracula = createUnifiedTheme({
  palette: {
    ...palettes.dark,  // based on light theme
    primary: {
      main: '#FFFFFF', // light blue
    },
    secondary: {
      main: '#565a6e', // Darker blue grey  
    },


    error: {
      main: '#8c4351',
    },
    warning: {
      main: '#8f5e15',
    },
    info: {
      main: '#6272A4',
    },
    success: {
      main: '#6272A4',
    },
    background: {
      default: '#282A36',
      paper: '#44475A', // Light grey  
    },
    link: '#FFFFFF',
    tabbar: {
      indicator: '#ffffff'
    },
    banner: {
      info: '#6272A4', // light blue banner
      error: '#8c4351',
      text: '#343b58',
      link: '#44475A',
    },

    errorBackground: '#8c4351',
    warningBackground: '#8f5e15',
    infoBackground: '#44475A',

    navigation: {
      submenu: {
        background: '#282A36', // light blue
      },
      background: '#44475A', // Lighter grey
      indicator: '#7DF3E1', // lilac as indicator  
      selectedColor: '#7DF3E1', // same as indicator
      color: '#F8F8F2', // dark blue for unselected items  
      navItem: {
        hoverBackground: '#FF5555', // light blue
      },
    },
  },
  pageTheme: {
    home: genPageTheme({ colors: ['#282A36', '#FF5555'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#282A36', '#FF5555'],
      shape: shapes.wave,
    }),
    project: genPageTheme({
      colors: ['#282A36', '#282A36'],
      shape: shapes.wave,
    }),
    tool: genPageTheme({
      colors: ['#FF5555', '#FF5555'],
      shape: shapes.round
    }),
    library: genPageTheme({
      colors: ['#FF5555', '#FF5555'],
      shape: shapes.round,
    }),
    technique: genPageTheme({ colors: ['#FF5555', '#FF5555'], shape: shapes.round }),
    other: genPageTheme({ colors: ['#282A36', '#FF5555'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#282A36', '#FF5555'], shape: shapes.wave }),
  },
  fontFamily: '"DIN OT", Helvetica, Arial, sans-serif',
  components: {
    MuiCssBaseline: {
      styleOverrides: theme => {
        const baseFn = defaultComponentThemes?.MuiCssBaseline?.styleOverrides;
        const baseStyles = typeof baseFn === 'function' ? baseFn(theme) : {};
        return {
          ...(baseStyles && typeof baseStyles === 'object' ? baseStyles : {}),
          '@font-face': [
            {
              fontFamily: 'DIN OT',
              src: `url('${DINOTLight}') format('truetype')`,
              fontWeight: 300,
              fontStyle: 'normal',
            },
            {
              fontFamily: 'DIN OT',
              src: `url('${DINOTRegular}') format('truetype')`,
              fontWeight: 400,
              fontStyle: 'normal',
            },
            {
              fontFamily: 'DIN OT',
              src: `url('${DINOTMedium}') format('truetype')`,
              fontWeight: 500,
              fontStyle: 'normal',
            },
            {
              fontFamily: 'DIN OT',
              src: `url('${DINOTBold}') format('truetype')`,
              fontWeight: 700,
              fontStyle: 'normal',
            },
          ],
        };
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Remove uppercase text  
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#FF5555', // light blue on hover
          },
          color: '#111111',
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: '#FF5555', // light blue on hover
          },
          color: '#111111',
        },
        textPrimary: {
          '&:hover': {
            backgroundColor: '#FF5555' // light blue on hover
          },
          color: '#ffffff'
        },
        textSecondary: {
          '&:hover': {
            backgroundColor: '#FF5555' // light blue on hover
          },
          color: '#ffffff'
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          color: '#FFFFFF'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#ffffff'
        }
      }
    }
  }
});  